import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const mercadoPagoOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS_MERCADOPAGO,
    steps: [
        {
            id: "mp-welcome",
            title: "Configuração do Mercado Pago",
            description:
                "Configure a integração com o Mercado Pago para receber pagamentos via cartão, PIX e split automático.",
            position: "center",
        },
        {
            id: "mp-oauth",
            title: "Vincular conta OAuth",
            description:
                "Clique para vincular sua conta Mercado Pago via OAuth. Isso autoriza a plataforma a processar pagamentos.",
            targetId: "mp-oauth-btn",
            position: "bottom",
        },
        {
            id: "mp-token",
            title: "Conta Vinculada",
            description:
                "O access token é gerado automaticamente ao vincular via OAuth. Quando vinculada, a conta aparece com status verde.",
            targetId: "mp-oauth-btn",
            position: "top",
        },
        {
            id: "mp-split",
            title: "Taxa de Split",
            description:
                "Defina a porcentagem de comissão da plataforma em cada corrida. Este valor é retido automaticamente pelo Mercado Pago.",
            targetId: "mp-split-fee",
            position: "bottom",
        },
        {
            id: "mp-save",
            title: "Salvar Configurações",
            description:
                "Após preencher os dados, clique em salvar. As configurações entram em vigor imediatamente para novas corridas.",
            targetId: "mp-save-btn",
            position: "top",
        },
    ],
};
